import PlaceIcon from '@material-ui/icons/Place';
import React from 'react';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import CONFIG from './config';

interface EnterYourAddressProps {
  setUserLocation: ({ lat, lng, manual }) => void;
}

interface EnterYourAddressState {
  address: string;
}
 
class EnterYourAddress extends React.Component<EnterYourAddressProps, EnterYourAddressState> {
  constructor(props) {
    super(props);
    this.state = { address: '' };
  }
 
  handleChange = address => {
    this.setState({ address });
  };
 
  handleSelect = address => {
    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then(latLng => this.props.setUserLocation({ lat: latLng.lat, lng: latLng.lng, manual: true }))
      .catch(error => console.error('Error', error));
  };
 
  render() {
    return (
      <PlacesAutocomplete
        value={this.state.address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
        searchOptions={{
          location: new google.maps.LatLng(CONFIG.geocentre.lat, CONFIG.geocentre.lng),
          radius: 20000,
          types: ['geocode'],
          componentRestrictions: { country: 'AU' },
        }}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div style={{paddingBottom: '10px'}}>
            <input
              {...getInputProps({
                placeholder: 'Enter your address...',
                className: 'location-search-input',
              })}
            />
            {suggestions.length > 0 && (<div className="autocomplete-dropdown-container">
              {loading && <div>Loading...</div>}
              {suggestions.map(suggestion => {
                const className = suggestion.active
                  ? 'suggestion-item--active'
                  : 'suggestion-item';
                // inline style for demonstration purpose
                const style = suggestion.active
                  ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                  : { backgroundColor: '#ffffff', cursor: 'pointer' };
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                  >
                  <span>
                    <PlaceIcon fontSize='small'/> <b>{suggestion.formattedSuggestion.mainText}</b>, {suggestion.formattedSuggestion.secondaryText}
                  </span>
                  </div>
                );
              })}
            </div>)}
          </div>
        )}
      </PlacesAutocomplete>
    );
  }
}

export default EnterYourAddress;